import { useState } from "react";
import LottieFromUrl from "../../../components/LottieFromUrl/LottieFromUrl";
import { closeIcon } from "../../../appAssets";
import { TaskData } from "../types";
import "./BingoView.scss";
import Lottie from "lottie-react";
import saveButton from "../../../appAssets/jsons/saveButton.json";

interface BingoViewProps {
  title: string;
  bingoGridArr: TaskData[];
  callbackData: (selected: { id: number; title?: string }[]) => void;
  onClose: () => void;
}

function BingoView({
  title,
  bingoGridArr,
  callbackData,
  onClose,
}: BingoViewProps) {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const checkForBingo = (selected: number[]): boolean => {
    const ids: (number | null)[] = bingoGridArr.map((i) => i.id);
    while (ids.length < 9) ids.push(null);

    const grid = [
      [ids[0], ids[1], ids[2]],
      [ids[3], ids[4], ids[5]],
      [ids[6], ids[7], ids[8]],
    ];

    for (let i = 0; i < 3; i++) {
      if (grid[i].every((id) => id != null && selected.includes(id)))
        return true;
      if (
        grid
          .map((row) => row[i])
          .every((id) => id != null && selected.includes(id))
      )
        return true;
    }
    if (
      [grid[0][0], grid[1][1], grid[2][2]].every(
        (id) => id != null && selected.includes(id),
      )
    )
      return true;
    if (
      [grid[0][2], grid[1][1], grid[2][0]].every(
        (id) => id != null && selected.includes(id),
      )
    )
      return true;

    return false;
  };

  const toggleSelect = (id: number) => {
    const newSelected = selectedIds.includes(id)
      ? selectedIds.filter((s) => s !== id)
      : [...selectedIds, id];

    setSelectedIds(newSelected);

    if (checkForBingo(newSelected)) {
      const isSelectedData = bingoGridArr
        .filter((item) => newSelected.includes(item.id))
        .map((item) => ({ id: item.id, title: item.title }));
      callbackData(isSelectedData);
    }
  };

  const handleSave = () => {
    const selected = bingoGridArr
      .filter((item) => selectedIds.includes(item.id))
      .map((item) => ({ id: item.id, title: item.title }));
    callbackData(selected);
  };

  return (
    <div className="bingo">
      <div className="bingo__top-actions">
        <div
          // type="button"
          // className="bingo__save-action"
          onClick={handleSave}
          // aria-label="Save"
        >
          <Lottie
            animationData={saveButton}
            loop={false}
            autoplay={false}
            className="bingo__save-action"
          />
          {/* <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg> */}
        </div>
        <button
          type="button"
          className="bingo__close-action"
          onClick={onClose}
          aria-label="Close"
        >
          <img src={closeIcon} alt="Close" className="bingo__close-icon" />
        </button>
      </div>

      <div className="bingo__main">
        <div className="bingo__title-col">
          <h1 className="bingo__title">{title}</h1>
        </div>

        <div className="bingo__grid">
          {bingoGridArr.map((item) => {
            const isSelected = selectedIds.includes(item.id);
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => toggleSelect(item.id)}
                className={`bingo__cell${isSelected ? " bingo__cell--selected" : ""}`}
              >
                {isSelected ? (
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  <LottieFromUrl
                    url={item.iconUrl}
                    className="bingo__cell-icon"
                  />
                )}
                <span
                  className={`bingo__cell-title${isSelected ? " bingo__cell-title--selected" : ""}`}
                >
                  {item.title}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default BingoView;
